import { render } from "./MetawebBusinessClassDialog.vue?vue&type=template&id=e56464ec&ts=true"
import script from "./MetawebBusinessClassDialog.vue?vue&type=script&lang=ts"
export * from "./MetawebBusinessClassDialog.vue?vue&type=script&lang=ts"

import "./MetawebBusinessClassDialog.vue?vue&type=style&index=0&id=e56464ec&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__